import { IJbpGlobalPartnerData } from 'legacy/lut/features/globalPartner/models/iJbpGlobalPartnerData'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { mapSpToFront } from './mappers'

export interface ISpJbpGlobalPartnerDataParameters {
  partnerId: string
  fYear: number
}

export const callSpJbpGlobalPartnerData = async ({
  partnerId,
  fYear,
}: ISpJbpGlobalPartnerDataParameters): Promise<IJbpGlobalPartnerData | null> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGlobalPartnersData/call`)

  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const payload = {
    'p.PartnerID': partnerId,
    'p.FYear': fYear,
  }

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return response.Data.map(mapSpToFront)[0]
  } catch (e) {
    return null
  }
}
